import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  pieceLinkMiniGame,
  setDataPopupError,
  setOpenPopupGivePiece,
} from "../../../../../../Redux/futures/mini-game/action";
import {
  TYPE_GIVE_MINIGAME,
  TYPE_GIVE_PIECE,
} from "../../../../../../helper/const";
import { curStateMiniGame } from "../../../../../../Redux/selector";
import { useTranslation } from "react-i18next";

export default function ComponentGive({ bgHeader, pieceA, data = {} }) {
  const { t } = useTranslation();
  const [totalGive, setTotalGive] = useState(1);
  const dispatch = useDispatch();
  const dataMiniGame = useSelector(curStateMiniGame);

  const handleMinus = () => {
    if (totalGive === 1) {
      return null;
    }

    setTotalGive((prev) => prev - 1);
  };

  const handleAdd = () => {
    if (totalGive === data.num) {
      return null;
    }

    setTotalGive((prev) => prev + 1);
  };

  const afterRequest = (data, isLoading, dataError) => {
    if (data && data?.data?.code) {
      dispatch(
        setOpenPopupGivePiece({
          isShow: true,
          link: `http://reverseauction.com.mm/mini-game/give/${data.data.code}?giveId=2`,
          type: TYPE_GIVE_PIECE.shareLink,
        })
      );
    } else if (dataError) {
      dispatch(
        setDataPopupError({
          isOpen: true,
          message: "",
        })
      );
    }
  };

  const handleGive = () => {
    const dataApi = {
      type: TYPE_GIVE_MINIGAME.give,
      piece_id: data.id,
      callback: afterRequest,
      piece_number: totalGive,
    };
    dispatch(pieceLinkMiniGame(dataApi));
  };
  return (
    <>
      <div className='header-mini-popup-rule'>
        <img src={bgHeader} alt='' className='img-rule-mini' />
        <div className='content-rule-mini'>
          {t("mini_game.pop_up_give_piece.title")}
        </div>
      </div>
      <div className='box-content-minigame-popup__container container-give-piece'>
        <p className='title-have'>
          {t("mini_game.pop_up_puzzle_piece.you_have")}
        </p>
        <div className='piece-container'>
          <img src={data.image_light} alt='' className='piece-image' />
          <p className='piece-name' style={{ textAlign: "center" }}>
            {totalGive} prize {data.awardName} - Piece ({data.name})
          </p>
        </div>

        <p className='title-give'>
          {t("mini_game.pop_up_give_piece.want_to_give")}
        </p>
        <div className='btn-container'>
          <button onClick={handleMinus}>-</button>
          <input className='btn-total' value={totalGive} />
          <button onClick={handleAdd}>+</button>
        </div>
        <button className='btn-give-piece' onClick={handleGive}>
          {t("mini_game.pop_up_give_piece.give")}
        </button>
        <p className='footer-text'>
          {`${t("mini_game.pop_up_give_piece.can_only_give").replace(
            "X",
            dataMiniGame.configMiniGame?.minigame?.max_give_piece
          )} ${t("mini_game.pop_up_give_piece.turns_left").replace(
            "X",
            dataMiniGame.configMiniGame?.giveReceiveTurnLeft
          ).replace("pieces", dataMiniGame.configMiniGame?.giveReceiveTurnLeft > 1 ? "pieces" : "piece")}`}
        </p>
      </div>
    </>
  );
}
